import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import { TEXT_ABOUT_US } from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BANNER_BLUE,
  STYLE_HEADING_1,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";

const AboutBanner = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  return (
    <div
      className={`${STYLE_BANNER_BLUE} mt-16 md:mt-[72px] relative`}
      style={{
        backgroundImage: isMobile
          ? `url(/images/aboutusbanner_mb.png)`
          : `url(/images/aboutus_banner_blue.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
        backgroundSize: "cover",
      }}
    >
      {!isMobile && (
        <img
          src={"/images/aboutus_icon_banner.svg"}
          className={`border-none h-[187px] md:h-img_banner mx-auto absolute bottom-[0.7px] left-1/2 transform -translate-x-1/2`}
        />
      )}

      <div className={`${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP}`}>
        <ProgramGoBack
          marginarrow="md:ml-9"
          title={TEXT_ABOUT_US[language]}
          textcolor={`${STYLE_HEADING_1(language)}`}
        />
      </div>
    </div>
  );
};

export default AboutBanner;
